export default {
  state: {
    counties: [],
    loading: false,
  },
  getters: {
    counties: state => state.counties,
    loading: state => state.loading,
  },
  mutations: {
    setCounties(state, counties) {
      state.counties = counties;
    },
    setLoading(state, display) {
      state.loading = display;
    }
  },
  actions: {
    async fetchAll({ commit }) {
      commit('setLoading', true);
      try {
        const counties = await axios.get('api/counties');
        commit('setCounties', counties);
      } catch (e) {
      }
      commit('setLoading', false);
    },

    async fetch({ commit }, id) {
      try {
        return await axios.get('api/counties/' + id);
      } catch (e) {
      }
    },

    async add({ commit }, payLoad) {
      await axios.post('api/counties', payLoad);
    },

    async update({ commit }, payLoad) {
      await axios.put('api/counties', payLoad);
    },

    async delete({}, id) {
      await axios.delete('api/counties/' + id);
    }
  },
};
